// Wrapper minimal Plausible / GA4 — silencieux si non configuré.

type EventProps = Record<string, string | number | boolean>;

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: EventProps }) => void;
    gtag?: (...args: unknown[]) => void;
  }
}

let injected = false;

function injectPlausible(domain: string) {
  if (injected || typeof document === "undefined") return;
  if (document.querySelector('script[data-plausible]')) {
    injected = true;
    return;
  }
  const s = document.createElement("script");
  s.defer = true;
  s.dataset.domain = domain;
  s.dataset.plausible = "true";
  s.src = "https://plausible.io/js/script.outbound-links.js";
  document.head.appendChild(s);
  injected = true;
}

export function initAnalytics() {
  const domain = import.meta.env.VITE_PLAUSIBLE_DOMAIN;
  if (domain) injectPlausible(domain);
}

export function trackEvent(name: string, props?: EventProps) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.plausible === "function") {
      window.plausible(name, props ? { props } : undefined);
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", name, props ?? {});
    }
  } catch {
    /* fail-silent : analytics ne doit jamais casser l'UX */
  }
}
